import {atom} from 'jotai'
import {ListFilter, PackageList} from '../domain'

const list: PackageList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 1,
    pageSize: 1,
    totalCount: 1,
  },
}

export const listAtom = atom<PackageList>(list)
export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'crtdOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  // search: {
  //   value: '',
  //   keyList: []
  // },
})

export const listActiveAtom = atom<PackageList>(list)
export const listActiveFilterAtom = atom<ListFilter>({
  filterList: [
    {
      key: 'stts',
      value: ['1'],
      operator: 3,
    },
  ],
  orderList: [{type: 2, key: 'crtdOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 999999999,
  },
})
